export default {"src":"/_next/static/media/logo-white.88561ed0.svg","height":53,"width":116,"blurWidth":0,"blurHeight":0};